export const SET_ACTIVE_MODAL: string = "SET_ACTIVE_MODAL";
export const NO_MODAL: number = 0;
export const LOGIN_MODAL: number = 1;
